import React from 'react';
import Cookie from '../defaults/Cookie';

export default (props) => {
  return (
    <Cookie />
  );
}
